


import { Button } from "primereact/button"
import { Card } from "primereact/card"
import { Password } from "primereact/password";
import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../service/authentication/AuthenticationService";
import { useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";

interface ToastState {
    visible: boolean;
    severity: string;
    message: string;
}

export const ResetPassword = () => {
    const location = useLocation();
    const [newPassword, setNewPassword] = useState<string>("");
    const [confirmNewPassword, setConfirmNewPassword] = useState<string>("");
    const [pwdError, setPwdError] = useState(false);
    const [tenancyName, setTenancyName] = useState<string | null>('');
    const [noTenancy, setNoTenancy] = useState<boolean>(false);
    const validPassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    const navigate = useNavigate();
    const [toast, setToast] = useState<ToastState>({ visible: false, severity: "", message: "" });

    // Extract token from URL when component mounts
    const email = location.pathname.split('/')[2]; // Gets the UUID part of the URL

    const handleNoTenancyChange = (e: any) => {
        setNoTenancy(e.checked);
        if (e.checked) {
            setTenancyName(null);
        }
    };

    const showToast = (severity: string, message: string): void => {
        setToast({ visible: true, severity, message });
        setTimeout(() => {
            setToast({ visible: false, severity: "", message: "" });
        }, 3000);
    };

    const handleChangePassword = async () => {
        // Validate tenancy name
        if (!noTenancy && tenancyName === undefined) {
            showToast("error", '');
            // toast.current.show({ severity: 'error', summary: 'Error', detail: '', life: 3000 });
            return;
        }

        if (tenancyName && noTenancy) {
            showToast("error", 'Cannot have both tenancy name and "No Tenancy" checked');
            // toast.current.show({ severity: 'error', summary: 'Error', detail: 'Cannot have both tenancy name and "No Tenancy" checked', life: 3000 });
            return;
        }

        if (newPassword.length === 0 || confirmNewPassword.length === 0) {
            showToast("error", 'Please provide all the field!');
            // toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please provide all the field!', life: 3000 })
            return;
        }

        if (newPassword !== confirmNewPassword) {
            showToast("error", 'New password and confirm new password should be same!');
            // toast.current.show({ severity: 'error', summary: 'Error', detail: 'New password and confirm new password should be same!', life: 3000 })
            return;
        }

        if (!validPassword.test(confirmNewPassword)) {
            setPwdError(true)
            return;
        }

        const inputForResetPassword = {
            Email: email,
            TenancyName: noTenancy ? null : tenancyName,
            NewPassword: newPassword,
            ConfirmNewPassword: confirmNewPassword
        }

        const changePWD = await resetPassword(inputForResetPassword);
        if (changePWD.data.Error) {
            showToast("error", changePWD.data.Error);
            return;
        }

        if (changePWD.data.Success) {
            navigate('/login');
        }
    }

    const changePwdFooter = (
        <ul className="pl-2 mt-0 list-disc">
            <li className="py-1">At least one lowercase</li>
            <li className="py-1">At least one uppercase</li>
            <li className="py-1">At least one numeric</li>
            <li className="py-1">At least one special character</li>
            <li className="py-1">Minimum 8 characters</li>
        </ul>
    )

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            {/* <Toast ref={toast} /> */}
            {/* Toast notification */}
            {toast.visible && (
                <div className={`fixed top-4 right-4 p-4 rounded-md shadow-md ${toast.severity === "error" ? "bg-red-500 text-white" : "bg-green-500 text-white"
                    }`}>
                    <p>{toast.message}</p>
                </div>
            )}

            <Card className="w-full max-w-md shadow-lg">
                <div className="p-6 space-y-4">
                    <h2 className="text-2xl font-bold text-center text-gray-800">Reset Password</h2>
                    <div>
                        <InputText
                            placeholder="Enter tenancy name"
                            value={tenancyName || ''}
                            onChange={(e) => {
                                setTenancyName(e.target.value);
                                if (e.target.value) setNoTenancy(false);
                            }}
                            disabled={noTenancy}
                            className="w-full p-2 border rounded-md"
                        />
                    </div>
                    <div className="w-full password-field">
                        <Password
                            className="w-full"
                            inputClassName="w-full p-2 border rounded-md"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="New Password"
                            footer={changePwdFooter}
                            toggleMask
                        />
                        {pwdError && <span className='text-red-500 text-sm'>Password is invalid</span>}
                    </div>
                    <div className="w-full password-field">
                        <Password
                            style={{ width: '100%' }}
                            inputClassName="w-full p-2 border rounded-md"
                            value={confirmNewPassword}
                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                            placeholder="Confirm New Password"
                            footer={changePwdFooter}
                            toggleMask
                        />
                        {pwdError && <span className='text-red-500 text-sm'>Password is invalid</span>}
                    </div>
                    <div className="flex items-center space-x-2">
                        <Checkbox
                            inputId="noTenancy"
                            checked={noTenancy}
                            onChange={handleNoTenancyChange}
                        />
                        <label htmlFor="noTenancy" className="text-gray-700 cursor-pointer">
                            No Tenancy (clear tenancy name)
                        </label>
                    </div>
                    <Button
                        label="Change Password"
                        onClick={handleChangePassword}
                        className="w-full py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
                    />
                </div>
            </Card>
        </div>
    )
}
